<template>
  
  <div class="avatar-bg-image" :style="computeBgImage">
    <img @error="avatarLoadError" @load="avatarLoaded" :src="src">
  </div>
 
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'avatar',
  props:{
    src:{default:""},
  },
  data(){
    return {
      bgUrl:undefined,
    }
  },
  components: {
   
  },
  computed:{
      ...mapState([
    'appSettings'
    ]),
     computeBgImage(){
      return {backgroundImage:'url('+this.bgUrl+')'}
    }
  },
  methods:{
    avatarLoaded(event){
      
      this.bgUrl=event.target.src;
  
    },
    avatarLoadError(){
      
      this.bgUrl=require('../assets/default_avatar.png');
     
    }
  },
  mounted:function(){
    
    this.bgUrl=this.src;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.avatar-bg-image{
  position:relative;
  display: inline-block;
  margin-bottom:15px;
  border-radius:999px;
  border:1px solid #999999;
  width:150px;
  height:150px;
  background-size: cover;
  background-position: center center
}
.avatar-bg-image img{
  display:none;
}

</style>
